import React from 'react';

// Empty-state mark for Feedback: a gradient envelope inside the shared
// gradient-bordered tile. Rendered at its native 80px (drawn in an 80x80
// viewBox); the frame is part of the artwork. Gradient ids are per-instance
// (useId) so multiple copies on a page don't collide.
const NoFeedbackIcon = ({ size = 80 }) => {
  const uid = React.useId();
  const g = (n) => `no_feedback_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="79" height="79" rx="11.5" stroke={`url(#${g(0)})`} />
      <rect x="19.25" y="25.25" width="41.5" height="28.5" rx="3.75" stroke={`url(#${g(1)})`} strokeWidth="2.5" />
      <path
        d="M20 26L40 41L60 26"
        stroke={`url(#${g(2)})`}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={g(0)} x1="40" y1="0" x2="40" y2="80" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7853F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(1)} x1="7" y1="31.75" x2="36.1916" y2="73.1832" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(2)} x1="10" y1="29.75" x2="19.863" y2="56.0514" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NoFeedbackIcon;
